import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderCyberSource } from '../../providers/payment/payment.cybersource'

/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.UK,
  regionId: 505,
  defaultCountryFrom: 'UK', // Silliness in Ria's database, this may need to switch to "GB" in the future?
  defaultCountryFromOnfido: 'GBR',
  defaultCountryCodeFrom: 44,
  defaultCurrencyFrom: 'GBP',
  defaultAmountFrom: 100,
  defaultLanguageCulture: 'en-GB',
  defaultLocation: {
    latitude: 55.378051,
    longitude: -3.435973
  },
  dateFormat: 'DD/MM/YYYY',   
  postalCodeRegex: `^([A-Z]{1,2}\\d[A-Z\\d]? ?\\d[A-Z]{2}|GIR ?0A{2})$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['en-GB'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderCyberSource(),
  isPlaidEnabled: false,
  isBankAccountEnabled:false,
  useSecurityQuestions: false,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 1,
  directBankBrand:'',
  distanceMetric: 'mi',
  acceptInternationalCards:false,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: true,
  isEMEA: true,
  notShowMarketingPushAlert: false,
  useVeriff: false,
  googlepayAdyenPaymentNetworks: ["masterCard", "visa"],
  applepayAdyenPaymentNetworks: ["masterCard", "visa"],
  adyenMerchantCapability: ["debit", "3ds", "credit"],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  walletServices:[],
  isCountrySupportDecimal: true,
  showNewHomePage: true,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "activity",
  adyenRegion: 'live'// https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/UK.ts